"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var core_1 = require("@material-ui/core");

var autobind_decorator_1 = __importDefault(require("autobind-decorator"));

var Datatable_1 = require("./Datatable");

var react_redux_1 = require("react-redux");

var DatatableBody =
/** @class */
function (_super) {
  __extends(DatatableBody, _super);

  function DatatableBody() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DatatableBody.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        isFetching = _a.isFetching,
        isColumnVisible = _a.isColumnVisible,
        renderRow = _a.renderRow,
        selected = _a.selected,
        data = _a.data,
        onSelect = _a.onSelect;
    return React.createElement(core_1.TableBody, {
      style: __assign({}, isFetching && {
        opacity: .4,
        pointerEvents: 'none'
      })
    }, children, data ? data.map(function (d, i) {
      var row = renderRow(d);
      return React.cloneElement(row, {
        key: d.id,
        index: i
      }, [onSelect && React.createElement(core_1.TableCell, {
        key: 1
      }, React.createElement(core_1.Checkbox, {
        checked: selected.indexOf(i) !== -1,
        onClick: _this.handleSelect(i)
      })), React.Children.map(row.props.children, function (c, j) {
        return isColumnVisible(j) && c;
      })]);
    }) : React.createElement(React.Fragment, null));
  };

  DatatableBody.prototype.handleSelect = function (i) {
    var _this = this;

    return function (event) {
      event.stopPropagation();
      var _a = _this.props,
          onSelect = _a.onSelect,
          selected = _a.selected;
      var x = selected.indexOf(i);

      if (x === -1) {
        selected.push(i);
      } else {
        selected.splice(x, 1);
      }

      onSelect(selected.slice());
    };
  };

  __decorate([autobind_decorator_1.default], DatatableBody.prototype, "handleSelect", null);

  return DatatableBody;
}(React.Component);

var state2props = function state2props(state, ownProps) {
  var paginateState = state.paginate[ownProps.name];
  return {
    isFetching: paginateState.isFetching,
    data: paginateState.entities
  };
};

exports.default = Datatable_1.datatableConsumer(react_redux_1.connect(state2props)(DatatableBody));